import React, { useEffect, useState } from 'react';
import ApplicationTable from '../../components/ApplicationTable';
import MultiSelectFilter from '../../components/MultiSelectFilter';
import AddApplicationModal from '../../components/AddApplicationModal';
import { subjectColumns, subjectColumnstable } from "../../components/ApplicationListData";
import { applicationService } from '../../services/applicationService';
import Filters from '../../components/MultiSelectFilter';
import { PlusIcon } from '@heroicons/react/24/outline';

function EducatorApplication({ permission }) {
    const [educatorApplicationList, setEducatorApplicationList] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modelType, setModelType] = useState('')
    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [pagination, setPagination] = useState({})
    const [allGradeList, setAllGradeLIst] = useState([])
    const [allSubjectListFilter, setAllSubjectListFilter] = useState([])
    const [allStatusList, setAllStatusList] = useState([])
    const [loader, setLoader] = useState(false)
    // State for all filters
    const [selectedFilters, setSelectedFilters] = useState({
        subject: [],
        grades: [],
        status: [],
    });
    const [selectedFiltersIds, setSelectedFiltersIds] = useState({
        subject: "",
        grades: "",
        status: "",
    });


    const filterConfigs = [
        { key: "subject", label: "All Subjects", options: allSubjectListFilter, color: "blue" },
        { key: "grades", label: "All Grades", options: allGradeList, color: "green" },
        { key: "status", label: "All Status", options: allStatusList, color: "orange" },
    ];

    useEffect(() => {
        getAllGradeData()
        getAllSubjectForFilter()
        getAllApplicationStatusForFilter()
    }, [])

    useEffect(() => {
        getEducatorApplicationList()
    }, [page, pageLimit, selectedFiltersIds?.subject, selectedFiltersIds?.grades, selectedFiltersIds?.status])

    async function getAllGradeData() {
        try {
            const response = await applicationService.getAllGrades()
            if (response?.success == true) {
                setAllGradeLIst(response?.data)
            } else {
                setAllGradeLIst([])
            }
        } catch (e) {
            console.error('Error fetching data:', e)
        }
    }

    async function getAllSubjectForFilter() {
        try {
            const response = await applicationService.getAllSubject()
            if (response?.success == true) {
                setAllSubjectListFilter(response?.data)
            } else {
                setAllSubjectListFilter([])
            }
        } catch (e) {
            console.error('Error fetching data:', e)
        }
    }

    async function getAllApplicationStatusForFilter() {
        try {
            const response = await applicationService.getAllApplicationStatusForFilter()
            if (response?.success == true) {
                setAllStatusList(response?.data)
            } else {
                setAllStatusList([])
            }
        } catch (e) {
            console.error('Error fetching data:', e)
        }
    }

    async function getEducatorApplicationList() {
        try {
            setLoader(true)
            let data = JSON.stringify({
                'page': page,
                'limit': pageLimit,
                'subject_id': selectedFiltersIds?.subject ? selectedFiltersIds?.subject : null,
                'grade_id': selectedFiltersIds?.grades ? selectedFiltersIds?.grades : null,
                'status': selectedFiltersIds?.status ? selectedFiltersIds?.status : null,
            })
            const response = await applicationService.getEducatorAllApplications(data)
            if (response?.response?.success == true) {
                setLoader(false)
                setEducatorApplicationList(response?.response?.data?.applications)
                setPagination(response?.pagination)
            } else {
                setLoader(true)
                setEducatorApplicationList([])
            }
        } catch (e) {
            setLoader(true)
            throw e
        }
    }
    return (
        <>
            <div className="space-y-6">
                <div className='flex items-center justify-between  p-4'>
                    <div>
                        {/* <MultiSelectFilter /> */}
                        <Filters filterConfigs={filterConfigs} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} selectedFiltersIds={selectedFiltersIds} setSelectedFiltersIds={setSelectedFiltersIds} />
                    </div>
                    {permission?.create === true && (
                        <div>
                            <button onClick={() => { setIsModalOpen(true); setModelType('New') }} className="bg-brandBlue text-white px-4 flex gap-2 py-2 rounded-lg hover:bg-brandBlue-600 transition">
                                <PlusIcon className="w-5 h-5 text-white" />  Add New Application  </button>
                        </div>
                    )}
                </div>

                {/* Educators can only view applications, not manage them */}
                <ApplicationTable loader={loader} columns={subjectColumns} data={educatorApplicationList} showActions={false} page={page} setPage={setPage} pageLimit={pageLimit} setPageLimit={setPageLimit} pagination={pagination} permission={permission} getAllApplicationList={getEducatorApplicationList} />
            </div>
            {permission?.create === true && (
                <AddApplicationModal
                    isOpen={isModalOpen}
                    onClose={setIsModalOpen}
                    type={modelType}
                    selectedApp={null}
                    setSelectedApp={() => { }}
                    setModelType={setModelType}
                    getAllApplicationList={() => { getEducatorApplicationList();}}
                />
            )}
        </>
    )
}

export default EducatorApplication